import { Grid, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { style } from "./style";
import Typography from "@material-ui/core/Typography";
import classNames from "classnames";
import SimplePieChart from "../booking/pieChart";
import _ from "lodash";
import Header from "../../../partials/header";

class DashboardAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // package: {},
      userCount: 0,
      serviceActive: 0,
      statusArray: [],
    };
  }
  async componentDidMount() {
    let result = await this.props.getServiceReportByPackage();
    if (result.code === 1 && result.data) {
      this.setState({
        serviceActive: result.data.serviceActive,
        statusArray: [
          {
            name: "gold",
            key: "gold",
            value: result.data.goldCount,
            color: "#eebe00",
          },
          {
            name: "silver",
            key: "silver",
            value: result.data.silverCount,
            color: "#9497a3",
          },
          {
            name: "bronze",
            key: "bronze",
            value: result.data.bronzeCount,
            value: 3,
            color: "#f37f00",
          },
          {
            name: "basic",
            key: "basic",
            value: result.data.basicCount,
            color: "#1ea000",
          },
          {
            name: "custom",
            key: "custom",
            value: result.data.customCount,
            color: "#3F98FF",
          },
        ],
      });
    }
  }
  render() {
    const { classes, t } = this.props;
    let { statusArray = [], serviceActive } = this.state;
    let dataMap = _.cloneDeep(statusArray);
    return (
      <React.Fragment>
        <Header
          session={t("sidebar_superadmin")}
          title={t("sidebar_dashboard")}
        />
        <Typography variant="h6" className={classes.labelChart}>
          {t("dashboard_admin_total_active_spa")}
        </Typography>
        <div className={classNames(classes.countReact, classes.countReactLike)}>
          {serviceActive}
        </div>
        {/* <Typography variant="h6" className={classes.labelChart}>
          {t("Tổng số user hoạt động")}
        </Typography>
        <div
          className={classNames(classes.countReact, classes.countReactHeart)}
        >
          200/2000
        </div> */}
        {/* <Toolbar total={totalBooking} fetchData={this.fetchData} /> */}
        <Paper className={classes.root}>
          <div className={classes.container}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4} md={4}>
                <div className={classes.colStatus}>
                  {statusArray.map((item, index) => {
                    return (
                      <div className={classes.row_info} key={index}>
                        <span
                          className={classNames(
                            classes["square" + "_" + statusArray[index].key],
                            classes.square
                          )}
                        ></span>
                        <span className={classes.infoTitle}>{t(item.key)}</span>
                      </div>
                    );
                  })}
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
                md={8}
                style={{ overflow: "auto", textAlign: "right" }}
              >
                <SimplePieChart data={dataMap} id="dashboard-bookingchart" />
              </Grid>
            </Grid>
          </div>
        </Paper>
      </React.Fragment>
    );
  }
}

DashboardAdmin.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  module: state.user.module,
});

const mapDispatch = (dispatch) => ({
  getServiceReportByPackage: dispatch.service.getServiceReportByPackage,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(style, { withTheme: true })(DashboardAdmin)
  )
);
